import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function FloatingWhatsApp() {
  return <a href="https://wa.me/12817980349" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-gradient-to-r from-gold to-gold-dark text-black rounded-full shadow-lg hover:scale-110 transition-transform duration-300 animate-gold-glow" aria-label="Contactar por WhatsApp" data-id="element-8">
      <MessageCircleIcon className="w-7 h-7" data-id="element-9" />

      {/* Pulse ring effect */}
      <span className="absolute inset-0 rounded-full border-2 border-gold animate-ping opacity-75" data-id="element-10"></span>
    </a>;
}